import React from 'react';
import MaxWidthStyled from './bundle.esm2.js';

const MaxWidth = (props) => {
  const { className, size = 1184, children, minPadding = 16 } = props;
  const { stretch = true } = props;
  return /* @__PURE__ */ React.createElement(MaxWidthStyled, {
    className: `MaxWidth ${className}`,
    maxSize: size,
    minPadding,
    stretch
  }, /* @__PURE__ */ React.createElement("div", {
    className: "MaxWidth__inner"
  }, children));
};
MaxWidth.defaultProps = {
  className: "",
  size: 1184,
  minPadding: 16,
  stretch: true
};

export { MaxWidth as default };
//# sourceMappingURL=bundle.esm.js.map
